import React, { useState } from 'react';
import Charts from './statistics/Charts';
import Reports from './statistics/Reports';
import './tabs.css';

const Statistics = () => {
  const [activeTab, setActiveTab] = useState('charts');

  return (
    <div className="content-container">
      {/* Tab Navigation */}
      <div className="tabs">
        <button
          className={activeTab === 'charts' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('charts')}
        >
          Charts
        </button>
        <button
          className={activeTab === 'reports' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('reports')}
        >
          Reports
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'charts' && <Charts />}
        {activeTab === 'reports' && <Reports />}
      </div>
    </div>
  );
};

export default Statistics;
